import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { Design} from '../designTest/designTest.model';


export interface TokenPayload {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  phone: string;
  type: string;
}
interface TokenResponse {
  token: string;
}
interface idArray{
  ids:string[]
}
export interface TestData {
  id: string;
  FirstName: string;
  LastName: string;
  Email: string;
  Phone: string;
  Type: string;
}

export interface UserDetails {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  // confirmpassword: string;
  phone: string;
  type;
  exp: number;
  iat: number;
}


@Injectable()
export class TestSchedulerService {

  private token: string;
  constructor(private http: HttpClient) {}
  private saveToken( token: string): void {
    localStorage.setItem('userToken', token);
    this.token = token;
  }

  private getToken(): string {
    if (!this.token) {
      this.token = localStorage.getItem('userToken');
      //
    }
    return this.token;
  }

  public getUserDetails(): UserDetails {
    const token = this.getToken();
    let payload;
    if (token) {
      //
      payload = token.split('.')[1];
      payload = window.atob(payload);
      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  public isLoggedIn(): boolean {
    const user = this.getUserDetails();
    if (user) {
      return user.exp > Date.now() / 1000;
    } else {
      return false;
    }
  }

  getColumns(): string[] {
    return ['FIRST NAME', 'LAST NAME', 'E-MAIL', 'PHONE NUMBER', 'EDIT', 'DELETE'];
  }
  getSAColumns(): string[] {
    return ['FIRST NAME', 'LAST NAME', 'E-MAIL', 'PHONE NUMBER', 'EDIT'];
  }

  // CreateTestScheduler............
  public createTestScheduler(user: TokenPayload,hostname): Observable<any> {

    var temp = { user, hostname };
    
    const b = this.http.post('/users/scheduler/createTestScheduler', temp);
    const request = b.pipe(
      map((data: TokenResponse) => {


        if (data.token) {
        this.saveToken(data.token);
        }
        return data;
      })
    );
    return request;
  }

  // display test_scheduler..........
  public test_scheduler(user: TestData): Observable<any> {
    const base = this.http.post('/users/scheduler', user);
    //
    const request = base.pipe(
      map((data: TokenResponse) => {


        // if (data.token) {
        //   this.saveToken(data.token);
        // }
        return data;
      })
    );
    return request;
  }




public fetchCollge=():Observable<any>=>{
  const base= this.http.get(`/users/scheduler/fetchcollege`)
  const request=base.pipe(
    map((data: TokenResponse)=>{
      return data

    })

  )
  return request;
   

}

public fetchColumns=(qsid: string):Observable<any>=>{
 
  const base= this.http.get(`/users/scheduler/fetchcategoryandcount/${qsid}`)
  const request=base.pipe(
    map((data: TokenResponse)=>{
      return data

    })

  )
  return request;
   

}


public fetchAnsweredStudents=(id: string):Observable<any>=>{
  console.log("in fetch students")
 
  const base= this.http.get(`/users/scheduler/fetchansweredstudent/${id}`)
  console.log("college_id",id)
  const request=base.pipe(
    map((data: TokenResponse)=>{
      return data

    })

  )
  return request;
   

}

public fetchUnAnsweredStudents=(id: string,idArray:idArray):Observable<any>=>{

 
 console.log("in fetching not logged in user******",idArray)
  const base= this.http.post(`/users/scheduler/fetchunansweredstudent/${id}`,idArray)
  console.log("college_id",id)
  const request=base.pipe(
    map((data: TokenResponse)=>{
      return data

    })

  )
  return request;
   

}


}
